import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import { Col, Row } from "antd";
import INPUT from './../../../../components/input/input';
import BUTTON from "./../../../../components/buttons/button";
import { color } from "./../../../../utils/themes/color";
import TEXTROW from "../../../../components/textRow";
import recycleImg from "./../../../../assets/images/recycleBin.jpg"


export default function PracticeAthlete(props) {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    const [data, setData] = useState([]);
    const [updator, setUpdator] = useState(1)

    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}users/get-practice-records-athlete/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    setData(response.data)
                    setLoading(false)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])

    const updatePracticeRecords = () => {

        if (user.time != "" && user.time != null && user.time != undefined && user.title != "" && user.title != null && user.title != undefined) {

            var x = [];
            for (const iterator of data) {
                x.push(
                    { "title": iterator.title, "time": iterator.time, "description": iterator.description }
                )
            }
            x.push(
                { "title": user.title, "time": user.time, "description": user.description }
            )

            var practice = { "practiceRecords": x }

            setLoading(true)
            Axios.patch(`${url}users/athlete-practice-records/${userId}`, practice)
                .then(async (response) => {

                    if (response.status === 200 || response.status === 201) {
                        setUpdator(updator + 1)
                        GreenNotif(response.message);
                        setLoading(false)

                    } else {
                        RedNotif(response.message);
                        setLoading(false)
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading(false)
                });

        } else {
            RedNotif("نام تمرین و مدت زمان انجام نمیتواند خالی باشد")
        }
    }


    const deletePracrice = (item) => {
        var x = [];

        data.filter(function (obj) {
            if (obj.title !== item.title) {
                x.push(obj)
            }
        });

        setData(x)

    }




    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>سوابق تمرینی خود را وارد نمایید:</p>
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>نام تمرین:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <INPUT
                            placeholder="مثلا هوازی"
                            i={(e) => setUser({ ...user, "title": e })}
                            value={user.title != undefined && user.title != null && user.title != "0" ? user.title : ""}
                        />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>مدت زمان انجام:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>                        </div>
                        <INPUT
                            placeholder="مثلا شش ماه"
                            i={(e) => setUser({ ...user, "time": e })}
                            value={user.time != undefined && user.time != null && user.time != "0" ? user.time : ""}
                        />
                    </Col>
                </Row>

                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>توضیحات بیشتر:</p>
                        </div>
                        <TEXTROW 
                        i={(e) => { setUser({ ...user, "description": e }) }} 
                        value={user.description != undefined && user.description != null && user.description != "0" ? user.description : ""} />
                    
                    </Col>
                </Row>
                <Row style={{ marginTop: '24px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <p style={{ color: color.secondary, fontWeight: 'bold' ,cursor: "pointer"}} onClick={(e) => 
                            {updatePracticeRecords()
                            setUser({ ...user, "time": "", "title": "", "description": "" })
                            }}
                            >افزودن</p>
                    </Col>
                </Row>

                <Row gutter={[8, 16]} style={{ marginTop: '32px' }} >
                    {data.map((item, index) =>
                        <Col offset={1} span={6} key={index} xxl={6} xl={6} lg={6} md={6} sm={6} style={{ border: `1px solid ${color.primary}`, background: "white", height: "120px" }}>

                            <Row style={{ margin: '18px' }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <p style={{ color: color.primary, fontSize: "20px" }}>{item.title}</p>
                                </Col>
                            </Row>

                            <Row style={{ margin: '18px' }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <p style={{ color: color.secondary, fontSize: "10px" }}>{item.time}</p>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '18px' }}>
                                <Col xxl={22} xl={22} lg={22} md={22} sm={22} style={{ marginBottom: '28px' }}>
                                    <p style={{ fontSize: "12px" }}>{item.description}</p>
                                </Col>
                                <Col xxl={2} xl={2} lg={2} md={2} sm={2} style={{ marginBottom: '28px' }}>
                                    <img src={recycleImg} style={{ width: "50%", cursor: "pointer" }} onClick={() => deletePracrice(item)} />
                                </Col>
                            </Row>

                        </Col>
                    )}

                </Row>



                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => {
                            updatePracticeRecords()
                            {
                                if (user.time != "" && user.time != null && user.time != undefined && user.title != "" && user.title != null && user.title != undefined) {
                                props.pager(3)
                                }
                            }
                            
                        }}
                            text="ثبت و بعدی" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) =>  props.pager(3)} text="رد کردن" type={"cancel"} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }

}